import util from '@bmp-vue/core/api/util'
import ui from '@bmp-vue/core/api/ui'
import multiplo from '../multiplo'
const controller = 'ActionRule'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  CalculaGridParcelas_ValorEntrada: function (model) {
    return new Promise((resolve, reject) => {
      const validations = [
        {
          invalid: model.VlrEntrada > model.VlrProdutoBem,
          msg: 'O Valor da Entrada deve ser menor que Valor do Veículo'
        },
        {
          invalid: model.VlrEntrada < (model.VlrProdutoBem * 0.2).toFixed(2),
          msg: 'O Valor da Entrada deve ser pelo menos 20% do Valor do Veículo'
        }
      ]
      resolve(getResponse(validations))
    })
  },

  EnviarPropostaAnalise_AvalistaObrigatorio: function (model, th) {
    return new Promise((resolve, reject) => {
      let validations = []
      if (model.Pessoa.TipoPessoa === 2) {
        const dto = { parameters: [{ name: 'CodigoProposta', value: model.Codigo }] }
        multiplo.ListPropostaAvalista(dto).then(function (response) {
          validations = [
            {
              invalid: response.Count <= 0,
              msg: 'Deve ser informado ao menos 1 Avalista'
            }
          ]

          resolve(getResponse(validations))
        })
      } else { resolve(getResponse(validations)) }
    })
  },

  Avalista_DocumentoEmitente: function (model, docPessoa) {
    return new Promise((resolve, reject) => {
      docPessoa = ui.Format.SomenteAlfanumerico(docPessoa)
      const docAvalista = ui.Format.SomenteAlfanumerico(model.DocumentoFederal)
      const validations = [
        {
          invalid: docPessoa && docPessoa === docAvalista,
          msg: 'O Documento informado é o mesmo do Emitente da Proposta'
        }
      ]
      resolve(getResponse(validations))
    })
  }
})

function getResponse (validations) {
  const dto = {
    rules: validations.map(p => !p.invalid), errors: validations.map(p => p.msg)
  }
  dto.hasAny = dto.rules.length > 0
  dto.hasErrors = dto.rules.some(p => !p)
  dto.errorMsg = !dto.hasErrors ? '' : validations.filter(p => p.invalid).map(p => p.msg).join('</br>')
  return dto
}
